// R8-IMP-DEDUP — storico degli import del listino (log leggero: data, file, conteggi
// nuove/aggiornate/da-verificare). Modale consultabile dal listino.
import React, { useState, useEffect } from 'react';
import { listino } from '../utils/api';

export default function ListinoStorico({ onChiudi }) {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    listino.importStorico()
      .then((r) => setJobs(r.data || []))
      .catch(() => setJobs([]))
      .finally(() => setLoading(false));
  }, []);

  const data = (s) => { try { return new Date(s).toLocaleString('it-IT'); } catch { return s || ''; } };

  return (
    <div onClick={onChiudi} style={overlay}>
      <div onClick={(e) => e.stopPropagation()} style={modal}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 14 }}>
          <h2 style={{ fontSize: 16, fontWeight: 500, margin: 0 }}>Storico import</h2>
          <button onClick={onChiudi} aria-label="Chiudi" style={x}>×</button>
        </div>
        {loading ? (
          <div style={{ color: 'var(--ds-muted)' }}>Caricamento…</div>
        ) : jobs.length === 0 ? (
          <div style={{ color: 'var(--ds-muted)', padding: 20, textAlign: 'center' }}>Nessun import ancora.</div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            {jobs.map((j) => (
              <div key={j.id} style={riga}>
                <div style={{ display: 'flex', justifyContent: 'space-between', gap: 10 }}>
                  <div style={{ fontSize: 13, color: 'var(--ds-text)' }}>{j.nome_file || 'Import PDF'}</div>
                  <div style={{ fontSize: 11, color: 'var(--ds-muted)', whiteSpace: 'nowrap' }}>{data(j.created_at)}</div>
                </div>
                <div style={{ fontSize: 12, marginTop: 3, color: 'var(--ds-muted)' }}>
                  {j.stato === 'errore'
                    ? <span style={{ color: 'var(--ds-danger)' }}>Errore: {j.errore || 'import non riuscito'}</span>
                    : j.stato === 'in_corso'
                    ? <span>In corso…</span>
                    : <span>{j.create} nuove · {j.aggiornate} aggiornate · {j.da_verificare} da verificare</span>}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

const overlay = { position: 'fixed', inset: 0, zIndex: 1000, background: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 };
const modal = { background: 'var(--ds-bg)', borderRadius: 'var(--radius-base)', width: '100%', maxWidth: 520, maxHeight: '80vh', overflowY: 'auto', padding: 20, boxShadow: '0 20px 60px rgba(0,0,0,0.25)' };
const riga = { border: '1px solid var(--ds-border)', borderRadius: 'var(--radius-base)', padding: '10px 12px', background: 'var(--chip)' };
const x = { background: 'none', border: 'none', cursor: 'pointer', fontSize: 22, color: 'var(--ds-muted)', width: 40, height: 40 };
